import React, { useEffect, useState } from 'react'
import api from '../api'
import { Plus, Lightbulb } from 'lucide-react'
import { Card, PageHeader, Button, Input, Field, Banner, Modal, ModalHeader, Alert } from '../components/ui'

export default function JenisPekerjaan() {
  const [data, setData] = useState([])
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState({ kode: '', nama: '', deskripsi: '', urutan: 0, bonus_rp: '' })
  const [editId, setEditId] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => { load() }, [])

  async function load() {
    const res = await api.get('/jenis-pekerjaan')
    setData(res.data)
  }

  function bukaTambah() {
    setForm({ kode: '', nama: '', deskripsi: '', urutan: data.length + 1, bonus_rp: '' })
    setEditId(null); setError(''); setModal(true)
  }

  function bukaEdit(j) {
    setForm({ kode: j.kode, nama: j.nama, deskripsi: j.deskripsi || '', urutan: j.urutan, bonus_rp: j.bonus_rp || '' })
    setEditId(j.id); setError(''); setModal(true)
  }

  async function simpan() {
    if (!form.kode || !form.nama) { setError('Kode dan nama wajib diisi'); return }
    try {
      if (editId) {
        await api.put(`/jenis-pekerjaan/${editId}`, { ...form, aktif: 1 })
      } else {
        await api.post('/jenis-pekerjaan', form)
      }
      setModal(false); load()
    } catch (e) {
      setError(e.response?.data?.message || 'Gagal menyimpan')
    }
  }

  async function nonaktifkan(id) {
    if (!window.confirm('Nonaktifkan jenis pekerjaan ini?')) return
    await api.delete(`/jenis-pekerjaan/${id}`)
    load()
  }

  const WARNA = ['#4f46e5', '#f72585', '#7c3aed', '#0ea5e9', '#10b981', '#f59e0b', '#4cc9f0', '#e11d48']

  return (
    <div>
      <PageHeader
        title="Jenis Pekerjaan"
        subtitle="Master data kode pekerjaan untuk template WA"
        actions={<Button icon={Plus} onClick={bukaTambah}>Tambah Jenis</Button>}
      />

      <Banner tone="brand">
        <Lightbulb size={15} style={{ flexShrink: 0 }} />
        Teknisi menggunakan <strong>kode</strong> saat laporan di WA. Contoh: <code style={{ background: '#e0e3fc', padding: '1px 6px', borderRadius: 4 }}>Pekerjaan : PSB</code>
      </Banner>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
        {data.map((j, i) => (
          <Card key={j.id} style={{ padding: 18, opacity: j.aktif ? 1 : 0.5, display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{
              width: 46, height: 46, borderRadius: 11, flexShrink: 0,
              background: WARNA[i % WARNA.length],
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontWeight: 700, fontSize: 13, letterSpacing: 0.5
            }}>{j.kode}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{j.nama}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{j.deskripsi || '-'}</div>
              {j.bonus_rp > 0 && <div style={{ fontSize: 11.5, color: 'var(--success)', marginTop: 2, fontWeight: 600 }}>+Rp {Number(j.bonus_rp).toLocaleString('id-ID')} / pekerjaan</div>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Button size="sm" variant="soft" onClick={() => bukaEdit(j)}>Edit</Button>
              {j.aktif && <Button size="sm" variant="danger-soft" onClick={() => nonaktifkan(j.id)}>Hapus</Button>}
            </div>
          </Card>
        ))}
      </div>

      {/* Modal */}
      {modal && (
        <Modal onClose={() => setModal(false)} width={400}>
          <ModalHeader title={editId ? 'Edit Jenis Pekerjaan' : 'Tambah Jenis Pekerjaan'} onClose={() => setModal(false)} />
          {error && <Alert type="error">{error}</Alert>}
          <Field label="Kode *" style={{ marginBottom: 14 }}>
            <Input value={form.kode} maxLength={5}
              onChange={e => setForm({ ...form, kode: e.target.value.toUpperCase() })}
              placeholder="PSB, GNG, dll (max 5 huruf)" />
          </Field>
          <Field label="Nama Jenis *" style={{ marginBottom: 14 }}>
            <Input value={form.nama} onChange={e => setForm({ ...form, nama: e.target.value })} placeholder="Pasang Baru" />
          </Field>
          <Field label="Deskripsi" style={{ marginBottom: 14 }}>
            <Input value={form.deskripsi} onChange={e => setForm({ ...form, deskripsi: e.target.value })} placeholder="Keterangan singkat" />
          </Field>
          <Field label="Urutan Tampil" style={{ marginBottom: 14 }}>
            <Input type="number" value={form.urutan} onChange={e => setForm({ ...form, urutan: parseInt(e.target.value) || 0 })} />
          </Field>
          <Field label="Bonus per Pekerjaan Selesai (Rp)" style={{ marginBottom: 22 }}>
            <Input type="number" value={form.bonus_rp} onChange={e => setForm({ ...form, bonus_rp: e.target.value })} placeholder="0 -- kosongkan kalau jenis ini tidak ada bonus" />
          </Field>
          <div style={{ display: 'flex', gap: 10 }}>
            <Button variant="neutral" onClick={() => setModal(false)} style={{ flex: 1, justifyContent: 'center' }}>Batal</Button>
            <Button onClick={simpan} style={{ flex: 1, justifyContent: 'center' }}>Simpan</Button>
          </div>
        </Modal>
      )}
    </div>
  )
}
